export const  GET_PARTNERS_REQUEST='partnersReducer/GET_PARTNERS_REQUEST';
export const  GET_PARTNERS_SUCCESS='partnersReducer/GET_PARTNERS_SUCCESS';
export const  GET_PARTNERS_FAILED='partnersReducer/GET_PARTNERS_FAILED';